import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { applyBufferData } from '../../actions/buffer';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as SurchargeInstruction[] | null;

const slice = createSlice({
  name: '$orderingProviderSurchargeInstructions',
  initialState,
  reducers: {
    setOrderingProviderSurchargeInstructions(
      state,
      action: PayloadAction<SurchargeInstruction[] | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetOrder, (_state, _action) => {
        return initialState;
      })
      .addCase(applyBufferData, (state, action) => {
        const { orderingProviderSurchargeInstructions } = action.payload;
        return orderingProviderSurchargeInstructions === undefined
          ? state
          : orderingProviderSurchargeInstructions;
      });
  },
});

export const { setOrderingProviderSurchargeInstructions } = slice.actions;
export default slice.reducer;
